import {withJsonFormsLayoutProps} from '@jsonforms/react';
import PropTypes from 'prop-types';
import CustomLayoutRenderer from '../CustomLayoutRenderer';

const VerticalLayout = ({
  schema,
  uischema,
  path,
  renderers,
  visible,
  label
}) => {
  const layoutProps = {
    elements: uischema.elements,
    schema: schema,
    path: path,
    direction: 'column',
    visible: visible,
    gap: uischema.gap,
    uischema: uischema,
    renderers: renderers,
    label: label
  };
  return <CustomLayoutRenderer {...layoutProps} />;
};

VerticalLayout.propTypes = {
  schema: PropTypes.object.isRequired,
  uischema: PropTypes.shape({
    elements: PropTypes.array.isRequired,
    gap: PropTypes.string
  }).isRequired,
  path: PropTypes.string,
  renderers: PropTypes.array.isRequired,
  visible: PropTypes.bool.isRequired,
  label: PropTypes.string
};

const VerticalLayoutControl = withJsonFormsLayoutProps(VerticalLayout);
VerticalLayoutControl.displayName = 'VerticalLayoutControl';

export {VerticalLayoutControl};
export default VerticalLayoutControl;
